<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    class="navbar-left"
    v-model="isShowDrawer"
    v-click-outside.stop="closeDrawer"
    clipped
  >
    <template v-slot:img>
      <v-img height="100%" src="@/assets/img/sidebar.png" gradient="to top right, rgba(0,7,71,.8), rgba(5,80,166,.9)"></v-img>
    </template>
    <v-list dense dark nav>
      <v-list-item-group>
        <v-divider class="divider--top"></v-divider>
          <!-- <v-avatar :src="'https://cdn.vuetifyjs.com/images/lists/1.jpg'"/> -->
        <v-list-item disabled>
          <v-list-item-avatar>
            <v-icon
              class="grey lighten-1 white--text"
            >mdi-account</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title v-text="mainName"></v-list-item-title>
            <v-list-item-subtitle v-text="subName"></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="divider--bottom"></v-divider>
        <v-list-item
          v-for="item in items[$store.state.user.role]"
          :key="item.text"
          active-class="secondary"
          @click.stop="toNext(item.to, item.blank)"
        >
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title class="list-title">
              {{ item.text }}
            </v-list-item-title>
          </v-list-item-content>

        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>


<script>
import ClickOutside from 'vue-click-outside'
import { logOut } from '../../plugins/auth'
export default {
  name: "VNavbarLeft",

  directives: {
    ClickOutside
  },

  data: () => ({
    isShowDrawer: false,
    items:{
        'Teacher': [
          { icon: 'mdi-home', text: 'トップページ', to: '/teacher/home' },
          { icon: 'mdi-history', text: '申し込み履歴画面', to: '/teacher/history' },
          { icon: 'mdi-file-document-outline', text: 'マニュアル', to: '/manual.pdf', blank: true },
          { icon: 'mdi-help', text: 'FAQ', to: '/faq.pdf', blank: true },
          { icon: 'mdi-logout', text: 'ログアウト', to: '/sign_in' },
        ],
        'Admin': [
          { icon: 'mdi-application-export', text: '学校別申し込み一覧', to: '/admin/home' },
          { icon: 'mdi-school', text: '学校一覧', to: '/admin/schools' },
          { icon: 'mdi-send-check-outline', text: '申込一覧', to: '/admin/temporary_schools' },
          { icon: 'mdi-bell', text: 'お知らせ', to: '/admin/notifications' },
          { icon: 'mdi-database-export', text: 'CSV出力', to: '/admin/csv_output' },
          { icon: 'mdi-logout', text: 'ログアウト', to: '/sign_in' },
        ]
    }
  }),

  watch: {
    drawer(now) {
      this.isShowDrawer = now;
    }
  },

  computed: {
    drawer() {
      return this.$store.state.drawer;
    },
    mainName() {
      return this.$store.getters['user/isAdmin']
        ? '新学社テスト作成システム'
        : this.$store.state.user.schoolData?.name
    },
    subName() {
      return this.$store.getters['user/isAdmin']
      ? 'システム管理者'
      : this.$store.state.user.uid + (this.$store.state.user.isDemo ? '（お試し）' : '')
    }
  },

  methods: {
    async toNext(path, isBlank) {
      if(path==='/sign_in') {
        logOut()
        await this.$axios.delete('/api/v1/auth/sign_out')
      }
      // 別ダブで開く
      if (isBlank) {
        window.open(path, '_blank')
      }
      // 現在の画面への遷移であればリロード
      else if (this.$route.path == path) {
        window.location.reload()
      }
      // それ以外は同一タブで画面遷移
      else {
        this.$router.push(path)
      }
    },
    closeDrawer(event) {
      // ipadのではmenuaアイコンクリック時に処理を行わない。
      if (typeof(event.target.className)==='string' && (event.target.className.includes('menu-icon__bars') || event.target.className.includes('menu-icon'))) return
      if (this.drawer) this.$store.commit('setDrawer', { drawer: !this.drawer })
    }
  },
}
</script>

<style lang="stylus">
.navbar-left
  position fixed
  z-index 1

.divider--top
  border-color #6790c0 !important

.divider--bottom
  border-color #6790c0 !important
  margin-bottom 5px

</style>
